import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AbstractActionService} from '../../../../../core/service/v2/service/action/abstractAction.service';
import {PayloadWithId} from '../../../../../core/service/payload/payloadWithId';
import {CustomizeHttpUrlGenerator} from '../../../../../../store/core/url/customizeHttpUrlGenerator';

@Injectable()
export class PaymentRequestDeleteAllMovementsService extends AbstractActionService<PayloadWithId, void> {

    constructor(customizeHttpUrlGenerator: CustomizeHttpUrlGenerator,
                httpClient: HttpClient) {
        super('PaymentRequest', 'remove-all-movements', customizeHttpUrlGenerator, httpClient);
    }
}
